import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IJobState} from "../reducers/job.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getJobState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.job);

export const getWebsiteJob = (websiteId: number) => createSelector(getJobState,
  (state: IJobState) =>
    state.entities[websiteId] ? state.entities[websiteId].entities : {}
);

export const getWebsiteJobLoading = (websiteId: number) => createSelector(getJobState,
  (state: IJobState) =>
    state.entities[websiteId] ? state.entities[websiteId].loading : false
);

export const getWebsiteJobLoaded = (websiteId: number) => createSelector(getJobState,
  (state: IJobState) =>
    state.entities[websiteId] ? state.entities[websiteId].loaded : false
);
